import { useEffect, useState } from "react";
import { useMyProfile } from "./profile-queries";

export { atCampus } from "./campus-queries";

/**
 * A list's campus filter that starts at the member's own campus (ADR 0036 amendment, the member's half), as Church
 * Center's campus choice "will set your campus filter when viewing other pages". The member can still clear it or
 * pick another; the choice on this page never changes their profile. Until the profile has loaded, or when the member
 * has no campus or no linked person, the filter is empty: every campus.
 */
export function useMyCampusFilter(): [string | null, (value: string | null) => void] {
  const profile = useMyProfile();
  const [campus, setCampus] = useState<string | null>(null);
  const [touched, setTouched] = useState(false);
  const mine = profile.data?.person.campus?.name ?? null;
  useEffect(() => {
    if (!touched && mine !== null) setCampus(mine);
  }, [mine, touched]);
  return [
    campus,
    (value) => {
      setTouched(true);
      setCampus(value);
    },
  ];
}
